import ActivityLogSession from "src/modules/communication-protobuf/private/ActivityLogSession";
import * as selectors from "src/modules/activity-log/duck/selectors";
import * as actions from "src/modules/activity-log/duck/actions";
import { saveActivityLog } from "src/modules/activity-log/ajax/cloud";
import { getStorageId } from "src/modules/activity-log/duck/selectors";
import { isFreemium } from "src/modules/auth/duck/selectors";
import debug from "src/modules/debug-logger";

const log = window.require("electron-log");

function createPbData(monitoring, getState) {
  return ActivityLogSession.createAndEncode({
    monitoringId: monitoring.monitoringId,
    startDate: new Date(monitoring.startDate).toISOString(),
    duration: monitoring.duration,
    deviceName: monitoring.deviceName,
    avatarId: monitoring.avatarId,
    events: monitoring.events,
    freemium: isFreemium(getState()),
    storageId: getStorageId(getState())
  });
}

export default function createMonitoringUploader({
  dispatch,
  getState,
  getCurrentMonitoringId
}) {
  const uploads = {};

  async function uploadMonitoring(monitoring) {
    if (!monitoring) return;
    if (uploads[monitoring?.monitoringId]) {
      return;
    }
    try {
      const pbData = createPbData(monitoring, getState);
      const promise = saveActivityLog({
        pbData,
        monitoringId: monitoring.monitoringId,
        avatarId: monitoring.avatarId,
        deviceName: monitoring.deviceName,
        startDate: monitoring.startDate,
        duration: monitoring.duration,
        storageId: getStorageId(getState())
      });
      uploads[monitoring.monitoringId] = promise;
      await promise;
      debug.activityLog("Monitoring successfully uploaded", monitoring);
      dispatch(actions.monitoringUploaded(monitoring.monitoringId));
    } catch (error) {
      delete uploads[monitoring.monitoringId];
      log.error(`uploadMonitoring failed`, error);
      return;
    }
  }
  async function processPendingMonitorings() {
    const monitoringsToUpload = Object.values(
      selectors.getMonitorings(getState())
    ).filter((monitoring) => !monitoring.isStructureUploaded);

    const promises = monitoringsToUpload.map(async (monitoring) => {
      if (monitoring.monitoringId === getCurrentMonitoringId()) return;
      if (monitoring.events.length === 0) {
        dispatch(actions.deleteMonitoring(monitoring.monitoringId));
        return;
      }

      // handle case where monitoring wasn't ended properly
      if (monitoring.duration == null) {
        const lastEvent = monitoring.events[monitoring.events.length - 1];
        return uploadMonitoring({
          ...monitoring,
          duration: lastEvent.start + lastEvent.duration
        });
      }
      return uploadMonitoring(monitoring);
    });
    await Promise.all(promises);
    const monitoringsToDelete = selectors.getMonitoringsToDelete(getState());
    monitoringsToDelete.forEach((monitoring) =>
      dispatch(actions.deleteMonitoring(monitoring.monitoringId))
    );
  }

  processPendingMonitorings();

  window.addEventListener("online", processPendingMonitorings);

  return {
    upload(id) {
      uploadMonitoring(selectors.getMonitoring(getState(), id));
    }
  };
}
